import axios from "axios";

import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

//const url = "https://dev.sanapp.info:3003/auth/";
//const url = "https://api-san-andres.vercel.app/auth/";
//const url = 'http://localhost:3005/auth/'
const url =`https://api.sanapp.info/auth/`;
/*
document.addEventListener('ionBackButton', (ev) => {
  ev.detail.register(10, () => {
    console.log('Handler was called!');
  });
});
*/

export function logInAdmin(data: any) {
  return axios.post(url + "admin", data).then((res: any) => {
    saveSesionDate(res.data.data, res.data.token);
    axios.defaults.headers.common["Authorization"] = res.data.token;
    return res.data;
  });
}

export function signUp(data: any) {
  return axios.post(url + "signup/", data).then((res: any) => {
    return res.data;
  });
}

const saveSesionDate = (data = {}, token: string) => {
  const newData = JSON.stringify(data);
  sessionStorage.setItem("usu", newData);
  sessionStorage.setItem("token", token);
  saveLocal(newData, token);
};

const saveLocal = async (data: string, token: string) => {
  await Storage.set({
    key: "user",
    value: data,
  });
  await Storage.set({
    key: "token",
    value: token,
  });
};
